import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
import { Container } from "../../../../eva-components/Container";
import { Breadcrumbs } from "../../../Breadcrumbs";
const HEADER_BREADCRUMBS_HEIGHT_VARIABLE = "--header-breadcrumb-height";
export const HeaderBreadcrumbs = ({ breadcrumbsList, useHeadingTagForBreadcrumbs = true, }) => {
    const ref = useRef(null);
    useEffect(() => {
        const updateHeight = () => {
            if (ref.current) {
                document.documentElement.style.setProperty(HEADER_BREADCRUMBS_HEIGHT_VARIABLE, `${ref.current.offsetHeight}px`);
            }
        };
        const resizeObserver = new ResizeObserver(updateHeight);
        if (ref.current) {
            resizeObserver.observe(ref.current);
        }
        return () => {
            resizeObserver.disconnect();
            document.documentElement.style.removeProperty(HEADER_BREADCRUMBS_HEIGHT_VARIABLE);
        };
    }, []);
    return (_jsx("div", { ref: ref, children: _jsx(Container, { children: _jsx(Breadcrumbs, { list: breadcrumbsList, useHeadingTag: useHeadingTagForBreadcrumbs }) }) }));
};
//# sourceMappingURL=HeaderBreadcrumbs.js.map